export default "__VITE_ASSET__DxQsa90P__"